// extracted by mini-css-extract-plugin
module.exports = {"drawerWidth":"20rem","drawerCollapsedWidth":"8rem"};